<template>
    <v-dialog
        v-model="showSubscriptionDialog"
        @input="tryCloseDialog"
        max-width="1200"
        scrollable
        transition="dialog-bottom-transition"
        :fullscreen="$vuetify.breakpoint.xsOnly"
    >
        <router-view
            :value="selectedSubscription"
            @input="Object.assign(selectedSubscription, $event)"
            :loading="$wait.is('loadingSubscriptions')"
        >
            <back-button @click="tryCloseDialog(false)"></back-button>
        </router-view>
    </v-dialog>
</template>

<i18n>
{
    "en": {
        "subscriptionsDialog.subscriptionNotFound": "There is no remaining reference to this subscription within the last 13 months of usage."
    }
}
</i18n>

<script>
import ApiV2 from '@/lib/ApiV2.ts';
import { waitFor } from '@/plugins/vue-wait';
import { toastError } from '@/components/Common/Toast.vue';
export default {
    data() {
        return {
            showSubscriptionDialog: false,
            showSubscriptionId: null,
            selectedSubscription: null,
        };
    },
    methods: {
        tryCloseDialog(isOpen) {
            if (!isOpen) {
                this.showSubscriptionDialog = false;
                this.showSubscriptionId = null;
                this.selectedSubscription = null;
            }
            this.$emit('input', isOpen);
        },
        loadSubscriptionDetails: waitFor('loadingSubscriptions', async function (id) {
            try {
                this.selectedSubscription = await ApiV2.http
                    .get(`/api/metadata/subscriptions/${id}`)
                    .then((r) => r.data);
                this.$title = this.selectedSubscription.subscriptionName;
            } catch (err) {
                toastError(this.$t('subscriptionsDialog.subscriptionNotFound'));
                this.tryCloseDialog(false);
            }
        }),
    },
    watch: {
        $route: {
            handler(to) {
                this.showSubscriptionId = to.params.subscriptionId || null;
                this.showSubscriptionDialog = !!this.showSubscriptionId;
                if (this.selectedSubscription && this.selectedSubscription.subscriptionId === this.showSubscriptionId) {
                    return;
                }
                if (!this.showSubscriptionId) return;
                this.loadSubscriptionDetails(this.showSubscriptionId);
            },
            immediate: true,
            deep: true,
        },
    },
};
</script>